import type {
  TimedActionListType,
  ContinuousMouseActionListType,
  ContinuousScrollActionListType,
  ContinuousParameterGroupType,
  ContinuousActionGroupType,
  TimedActionItemGroup,
  // Shared
  ActionListId,
} from '@packages/systems/ix2/types-core';

export const defaultContinuousParameterGroupConsts: {
  MOUSE_X: ContinuousParameterGroupType<'MOUSE_X'>;
  MOUSE_Y: ContinuousParameterGroupType<'MOUSE_Y'>;
  SCROLL_PROGRESS: ContinuousParameterGroupType<'SCROLL_PROGRESS'>;
} = {
  MOUSE_X: {
    id: null,
    type: 'MOUSE_X',
    parameterLabel: 'Mouse X',
    continuousActionGroups: [],
  },
  MOUSE_Y: {
    id: null,
    type: 'MOUSE_Y',
    parameterLabel: 'Mouse Y',
    continuousActionGroups: [],
  },
  SCROLL_PROGRESS: {
    id: null,
    type: 'SCROLL_PROGRESS',
    parameterLabel: 'Scroll',
    continuousActionGroups: [],
  },
};

export const defaultContinuousActionGroups: ContinuousActionGroupType = {
  keyframe: 0,
  actionItems: [],
};

export const defaultTimedActionItemGroups: TimedActionItemGroup = {
  actionItems: [],
};

const defaultActionListId = '' as ActionListId;

export const defaultTimedActionList: TimedActionListType = {
  id: defaultActionListId,
  origin: undefined,
  title: 'New timed animation',
  actionItemGroups: [],
  useFirstGroupAsInitialState: false,
  createdOn: null,
};

export const defaultContinuousMouseActionList: ContinuousMouseActionListType = {
  id: defaultActionListId,
  origin: undefined,
  title: 'New mouse animation',
  continuousParameterGroups: [
    defaultContinuousParameterGroupConsts.MOUSE_X,
    defaultContinuousParameterGroupConsts.MOUSE_Y,
  ],
  createdOn: null,
};

export const defaultContinuousScrollActionList: ContinuousScrollActionListType =
  {
    id: defaultActionListId,
    origin: undefined,
    title: 'New scroll animation',
    continuousParameterGroups: [
      defaultContinuousParameterGroupConsts.SCROLL_PROGRESS,
    ],
    createdOn: null,
  };
